import React, { useState }  from 'react'
import { Link, useNavigate } from 'react-router-dom';
import 'react-pro-sidebar/dist/css/styles.css';
import { BiUserCircle } from "react-icons/bi";
//import {FaArrowCircleRight, FaBolt, FaCircle, FaCogs, FaGem , FaGgCircle, FaHeart , FaHelicopter ,FaIcicles,FaInfo, FaList, FaRegUser, FaSignOutAlt, FaUser, FaUserCog } from 'react-icons/fa' ;
import {FaCogs, FaList, FaSignOutAlt, FaUser } from 'react-icons/fa' ;
import {  Col , Nav , Navbar , NavDropdown } from 'react-bootstrap' ;
import './Header.css';
import './Sidebar';
//import SidebarContext from '../../../store/sidebar-context';
import { useSelector,useDispatch } from "react-redux";
import {toggleAction} from '../../../store/index';
import { logout } from "../../login/loginSlice";

export default function Header(){
  const dispatch = useDispatch();
  const navigate= useNavigate();
  const logMeOut = () => {
    sessionStorage.removeItem("accessJWT");
    sessionStorage.removeItem("accessIsLogIn");
    sessionStorage.removeItem("accessUserID");
    localStorage.removeItem("accessIsLogIn");
    localStorage.removeItem("islogIn");
    localStorage.removeItem("crmSite");
    localStorage.removeItem("accessUserID");
     // CLEAR DATA FROM STORAGE
     localStorage.clear();
     sessionStorage.clear();
    dispatch(logout());
    
    navigate('/login', { replace: true });
  //  window.location.reload(true);
  }

 // console.log('name '+getUserProfile.name);
  const userData = useSelector((state) => state.user);
 // console.log(userData);
//console.log('userData 1 '+JSON.stringify(userData.user));

 const uData= JSON.parse(JSON.stringify(userData.user));

  //console.log('userData name '+uData.username);
  const userId = localStorage.getItem('accessUserID');
  console.log(userId);
 
  const userProfileUpdate = () => {
   
    //console.log('select role '+id);
    // navigate(`/modifyUser/`+ userId); 
    navigate(`/modifyUser/profile/`+userId)
 }
                
 //const userData= dispatch(getUserProfile());
 //console.log(userData);

 // const sidebarctx = useContext(SidebarContext);
 
 const sidebarctx = useSelector((state)=>state.adminsidebar.isToggle);
 //console.log('header '+sidebarctx);
    //create initial menuCollapse state using useState hook
const [menuCollapse, setMenuCollapse] = useState(false);

//let circleClasses = "inline-block p-7 rounded-full w-20 mx-auto";
let iconStyles = { color: "white", fontSize: "1.5em" };
//create a custom function that will change menucollapse state from false to true and true to false
const menuIconClick = () => {
 
  //condition checking to change state from true to false and vice versa
 // console.log('hello');
  menuCollapse ? setMenuCollapse(false) : setMenuCollapse(true);
 // sidebarctx.setCollapse(menuCollapse);
 dispatch(toggleAction.changeToggle());
  //console.log(menuCollapse);
};
    return (
     
          <Navbar className='navbar navbar-light bg-light justify-content-center sticky-top' collapseOnSelect expand="lg" bg="white" variant="light">
          <Col xs={2} sm={2} md={2}>
           <Navbar.Toggle aria-controls="responsive-navbar-nav"   variant="light" onClick={menuIconClick} />
           </Col>
          <Col xs={8} sm={10} md={8} className="justify-content-center">
          <Navbar.Brand href="#home"  className="justify-content-center"> <img src='/images/RATourlogo.webp'   className="justify-content-center logo-image"/></Navbar.Brand>
          </Col>
          <Col xs={2} sm={12} md={2}>
          <Navbar.Collapse  className="responsive-navbar-nav justify-content-end">
            
            <Nav className="mr-auto">
           
            <BiUserCircle className="fcolor userIcon"/><span className='username mt-2' > {uData.username}</span> 
     
              <NavDropdown title="" id="collasible-nav-dropdown Left-aligned" className='userDropdown'>
                <NavDropdown.Item   refresh="true" onClick={userProfileUpdate} ><FaUser className='fcolor' /> Profile</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2" ><FaCogs className='fcolor'/> Settings</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3" ><FaList className='fcolor'/> Activity Log</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#" onClick={logMeOut} refresh="true"><FaSignOutAlt className='fcolor' /> Logout</NavDropdown.Item>
              </NavDropdown>
            </Nav>
            
            <Nav>
           
          {/*  <Link to={"/logout"}></Link>  <Navbar.Brand href="#home">
            <Form>
                <Row md >
                      <Col>
                      <Form.Group controlId="formEmail">
                      <Form.Control  type="email" placeholder="Exemple@email.com" />
                      </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="formPassword">
                        <Form.Control  type="password" placeholder="password" />
                        </Form.Group>
                        </Col>
                        <Col className="social">
                        <Button variant="primary" type="submit">
            Sign in 
          </Button>
                        </Col>
                </Row>
              </Form> 
              </Navbar.Brand>  */}
            </Nav>
          </Navbar.Collapse>
          </Col>
        </Navbar>
    
      
    );
  }

 

  //export default Header;